import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();

  const isLinkActive = (path) => location.pathname === path;

  return (
    <nav style={styles.nav}>
      <h2 style={styles.logo}>Sidra Pizza & Sweets</h2>
      <div style={styles.links}>
        <Link to="/" style={isLinkActive('/') ? styles.activeLink : styles.link}>Home</Link>
        <Link to="/menu" style={isLinkActive('/menu') ? styles.activeLink : styles.link}>Customer Menu</Link>
        <Link to="/pos" style={isLinkActive('/pos') ? styles.activeLink : styles.link}>POS System</Link>
      </div>
    </nav>
  );
}

const styles = {
  nav: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 2rem', background: '#111827', color: '#fff' },
  logo: { margin: 0, fontSize: '1.25rem' },
  links: { display: 'flex', gap: '1.5rem' },
  link: { color: '#9CA3AF', textDecoration: 'none' },
  activeLink: { color: '#10B981', textDecoration: 'none', fontWeight: 'bold' }
};